import { render, staticRenderFns } from "./outboundDetails.vue?vue&type=template&id=919d648a&scoped=true"
import script from "./outboundDetails.vue?vue&type=script&lang=js"
export * from "./outboundDetails.vue?vue&type=script&lang=js"
import style0 from "./outboundDetails.vue?vue&type=style&index=0&id=919d648a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919d648a",
  null
  
)

export default component.exports